import React from "react";
import { FormHandles } from "@unform/core";

import { InputTypes } from "../UserData.screen";

import { cleanNumber, hasBlankSpace } from "../../../../Utils";

import { reduceFormErrors } from "./signUp.reduceFormErrors";

interface onChangeInputProps {
  length: number;
  handleValidation(): void;
  name: InputTypes;
  formRef: React.RefObject<FormHandles>;
}

export const onChange =
  ({ formRef, name, length, handleValidation }: onChangeInputProps) =>
  (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = cleanNumber(e?.target?.value);

    if (newValue?.length === length) {
      handleValidation();
      return;
    }

    const errors = reduceFormErrors(formRef, { [name]: undefined });
    formRef.current?.setErrors(errors);
  };

export const onChangeUsername =
  ({
    formRef,
    name,
  }: {
    name: InputTypes;
    formRef: React.RefObject<FormHandles>;
  }) =>
  (e: React.ChangeEvent<HTMLInputElement>): void => {
    const newValue = e?.target?.value;
    console.log(newValue);

    if (hasBlankSpace(newValue)) {
      const errors = reduceFormErrors(formRef, {
        username: "Não são permitidos espaços em branco",
      });
      formRef.current?.setErrors(errors);
      return;
    }

    const errors = reduceFormErrors(formRef, { [name]: undefined });
    formRef.current?.setErrors(errors);
  };

export const onChangePassword =
  ({
    formRef,
    name,
    setStatePassword,
  }: {
    name: InputTypes;
    formRef: React.RefObject<FormHandles>;
    setStatePassword(value: string): void;
  }) =>
  (e: React.ChangeEvent<HTMLInputElement>): void => {
    const newValue = e?.target?.value;
    setStatePassword(newValue);

    if (hasBlankSpace(newValue)) {
      const errors = reduceFormErrors(formRef, {
        password: "Não são permitidos espaços em branco",
      });
      formRef.current?.setErrors(errors);
      return;
    }

    const errors = reduceFormErrors(formRef, { [name]: undefined });
    formRef.current?.setErrors(errors);
  };
